








































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import OperateNormalOn from "../resources/operateNormalOn.vue";
import OperateNormalOff from "../resources/operateNormalOff.vue";
import OperateAddOn from "../resources/operateAddOn.vue";
import OperateAddOff from "../resources/operateAddOff.vue";
import OperateRemoveOn from "../resources/operateRemoveOn.vue";
import OperateRemoveOff from "../resources/operateRemoveOff.vue";

@Component({
  components: {
        ArrowDown,
        ArrowRight,
        OperateNormalOn,
        OperateNormalOff,
        OperateAddOn,
        OperateAddOff,
        OperateRemoveOn,
        OperateRemoveOff
  }
})
export default class PolygonOperate extends Vue {
  @Prop()
  private editMode!: number;

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  openStatus = {
    opend: true
  };

  polygonOperateContentsOpenAnimate = false;
  polygonOperateContentsCloseAnimate = false;

  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

  changeMode(mode){
    this.$emit("doCommand", "changeEditMode", { mode : mode });
  }


    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
